export default __webpack_public_path__ + "static/media/review.1c5383be.png";